"use strict"
const angular = require("angular")
import moment from "moment"

/*@ngInject*/
export function anytimeService($http, $q) {
  // AngularJS will instantiate a singleton by calling "new" on this function
  let storedAnytimeUnitAndCategoryGroupingMap
  let storedAnytimeMinNightsAndPricingDataAllUnits
  let storedAccomodationTypes
  let service = {
    getAccomodationTypes(campsiteName) {
      if (!storedAccomodationTypes) {
        return new Promise((resolve, reject) => {
          service.getAnytimeUnitAndCategoryGroupingMap(campsiteName).then((unitAndCategoryGrouping) => {
            const parentUnitDetailPromises = []
            const accomodationTypesData = []
            unitAndCategoryGrouping.unitGrouping.forEach(
              (unit) => {
                const promise = $http
                  .get(`/api/availability/GetAnytimeUnitDetail/${campsiteName}/${unit.parentId}`)
                  .then((resp) => {
                    const data = resp.data[0]
                    accomodationTypesData.push({ accommodationTypeID: data.id, name: data.name })
                  })
                parentUnitDetailPromises.push(promise)
              },
              (reject) => {
                //this is a rejection
                console.error(reject)
              }
            )
            $q.all(parentUnitDetailPromises).then(() => {
              storedAccomodationTypes = accomodationTypesData.sort(
                (a, b) => a.accommodationTypeID - b.accommodationTypeID
              )
              resolve(storedAccomodationTypes)
            })
          })
        })
      }
      return Promise.resolve(storedAccomodationTypes)
    },
    isCampsiteMultiPlot(campsiteName) {
      if (campsiteName === "tregarton") {
        return true
      } else {
        return false
      }
    },
    getAnytimeUnitAndCategoryGroupingMap(campsiteName) {
      if (storedAnytimeUnitAndCategoryGroupingMap) {
        return Promise.resolve(storedAnytimeUnitAndCategoryGroupingMap)
      }
      if (this.isCampsiteMultiPlot(campsiteName)) {
        return $http
          .get(`/api/availability/GetAnytimeAvailableUnitIdsForMultiPlotMode/${campsiteName}`)
          .then((response) => {
            const unitGrouping = new Map()
            response.data.forEach((item) => {
              const hasParentObject = unitGrouping.has(item.parent_unit_id)
              if (hasParentObject) {
                const parentObject = unitGrouping.get(item.parent_unit_id)
                const parentObjectSubUnitsCopy = [...parentObject.subUnitsArray]
                parentObjectSubUnitsCopy.push(item.sub_unit_id)
                unitGrouping.set(item.parent_unit_id, {
                  parentId: item.parent_unit_id,
                  subUnitsArray: parentObjectSubUnitsCopy,
                })
              } else {
                unitGrouping.set(item.parent_unit_id, {
                  parentId: item.parent_unit_id,
                  subUnitsArray: [item.sub_unit_id],
                })
              }
            })
            storedAnytimeUnitAndCategoryGroupingMap = { unitGrouping }
            return storedAnytimeUnitAndCategoryGroupingMap
          })
      } else {
        return $http.get(`/api/availability/GetAnytimeAvailableUnitIds/${campsiteName}`).then((response) => {
          const unitGrouping = new Map()
          const categoryGrouping = new Map()

          response.data.forEach((item) => {
            if (item.parent_id !== 0) {
              const hasParentObject = unitGrouping.has(item.parent_id)
              if (hasParentObject) {
                const parentObject = unitGrouping.get(item.parent_id)
                const parentObjectSubUnitsCopy = [...parentObject.subUnitsArray]
                parentObjectSubUnitsCopy.push(item.id)
                unitGrouping.set(item.parent_id, {
                  parentId: item.parent_id,
                  subUnitsArray: parentObjectSubUnitsCopy,
                })
              } else {
                unitGrouping.set(item.parent_id, {
                  parentId: item.parent_id,
                  subUnitsArray: [item.id],
                })
              }
              const hasCategoryObject = categoryGrouping.has(item.category_id)
              if (hasCategoryObject) {
                const categoryObject = categoryGrouping.get(item.category_id)
                const categoryObjectSubUnitsCopy = [...categoryObject.subUnitsArray]
                categoryObjectSubUnitsCopy.push(item.id)
                categoryGrouping.set(item.category_id, {
                  parentId: item.parent_id,
                  subUnitsArray: categoryObjectSubUnitsCopy,
                })
              } else {
                categoryGrouping.set(item.category_id, {
                  parentId: item.parent_id,
                  subUnitsArray: [item.id],
                })
              }
            }
          })

          storedAnytimeUnitAndCategoryGroupingMap = { unitGrouping, categoryGrouping }
          return storedAnytimeUnitAndCategoryGroupingMap
        })
      }
    },
    getMinNightsAndPricing(campsiteName) {
      if (storedAnytimeMinNightsAndPricingDataAllUnits) {
        return Promise.resolve(storedAnytimeMinNightsAndPricingDataAllUnits)
      } else {
        const parentIdsArray = []
        if (storedAnytimeUnitAndCategoryGroupingMap) {
          storedAnytimeUnitAndCategoryGroupingMap.unitGrouping.forEach((item) => {
            parentIdsArray.push(item.parentId)
          })
        }
        return $http
          .post(`/api/availability/GetAnytimePricing/${campsiteName}`, {
            data: parentIdsArray,
          })
          .then(
            (response) => {
              let anytimeMinNightsAndPricingDataAllUnits = []
              parentIdsArray.forEach((id) => {
                anytimeMinNightsAndPricingDataAllUnits[id] = []
                const dates = response.data.filter((item) => item.unit_id === id)
                dates.forEach((item) => {
                  const date = moment(item.day).format("YYYY-MM-DD")
                  const dateObject = anytimeMinNightsAndPricingDataAllUnits[id].find((item) => item.date === date)
                  if (dateObject) {
                    dateObject.details.push({ duration: item.duration, rate: item.rate })
                  } else {
                    anytimeMinNightsAndPricingDataAllUnits[id].push({
                      date,
                      minNights: item.min_period,
                      details: [{ duration: item.duration, rate: item.rate }],
                    })
                  }
                })
              })

              return anytimeMinNightsAndPricingDataAllUnits
            },
            (reject) => {
              //this is a rejection
              console.error(reject)
            }
          )
      }
    },
    getAnytimeUnitPriceForDuration(anytimeMinNightsAndPricingDataAllUnits, startDate, accomodationType, lengthOfStay) {
      const datesArray = anytimeMinNightsAndPricingDataAllUnits[accomodationType]

      const anytimeDateDetails = datesArray
        ? datesArray.find(
            (item, index) =>
              datesArray[index + 1] &&
              moment(startDate).isBetween(datesArray[index].date, datesArray[index + 1].date, undefined, "[)")
          )
        : null

      const detailsArray = anytimeDateDetails?.details

      const sortedDetailsArray = detailsArray
        ? detailsArray.sort(function (a, b) {
            return a.duration - b.duration
          })
        : []

      let pricePerDay = sortedDetailsArray.find((item, index) => sortedDetailsArray[index + 1]?.duration > lengthOfStay)
        ?.rate

      if (!pricePerDay) {
        pricePerDay = sortedDetailsArray[sortedDetailsArray.length - 1]?.rate
      }

      if (pricePerDay) {
        const priceForUnitType = lengthOfStay * pricePerDay
        return priceForUnitType
      }
    },
  }

  return service
}

export default angular.module("makeamapAngularApp.anytimeService", []).service("anytimeService", anytimeService).name
